function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Se_svg__cls-1{fill:#006aa7}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "Se_svg__cls-1",
  d: "M7 9V.46A10 10 0 00.05 9zM9 9h11a10 10 0 00-10-9c-.34 0-.67 0-1 .05zM7 11H.05a10 10 0 007 8.54zM9 11v9c.33 0 .66.05 1 .05a10 10 0 0010-9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9V.05a10.14 10.14 0 00-2 .41V9H.05v1c0 .34 0 .67.05 1H7v8.54A10.14 10.14 0 009 20v-9h11c0-.33.05-.66.05-1s0-.67-.05-1z",
  fill: "#fecc00"
});

function SvgSe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Se_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDA2YWE3O30uY2xzLTJ7ZmlsbDojZmVjYzAwO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03LDlWLjQ2QTEwLDEwLDAsMCwwLC4wNSw5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTksOUgyMEExMCwxMCwwLDAsMCwxMCwwYy0uMzQsMC0uNjcsMC0xLC4wNVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03LDExSC4wNWExMCwxMCwwLDAsMCw3LDguNTRaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNOSwxMXY5Yy4zMywwLC42Ni4wNSwxLC4wNWExMCwxMCwwLDAsMCwxMC05WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTksOVYuMDVBMTAuMTQsMTAuMTQsMCwwLDAsNywuNDZWOUguMDVjMCwuMzMsMCwuNjYsMCwxczAsLjY3LjA1LDFIN3Y4LjU0QTEwLjE0LDEwLjE0LDAsMCwwLDksMjBWMTFIMjBjMC0uMzMuMDUtLjY2LjA1LTFzMC0uNjctLjA1LTFaIi8+PC9zdmc+";
export { SvgSe as ReactComponent };